/* Spanish (Spain, International Sort) locale settings for Webix */
webix.i18n.locales['es-ES'] = {
    groupDelimiter: '.', // Delimiter for groups of thousands
    groupSize: 3, // Size of groups of thousands
    decimalDelimiter: ',', // Delimiter for decimal part
    decimalSize: 2, // Number of decimal places
    dateFormat: '%d/%n/%Y', // Date format
    timeFormat: '%G:%i', // Time format
    longDateFormat: '%d %F %Y', // Long date format
    fullDateFormat: '%d %F %Y %G:%i', // Full date and time format
    am: null, // AM marker (not used in this locale)
    pm: null, // PM marker (not used in this locale)
    price: '{obj} €', // Price format
    priceSettings: {
        groupDelimiter: '.', // Delimiter for groups of thousands in prices
        groupSize: 3, // Size of groups of thousands in prices
        decimalDelimiter: ',', // Delimiter for decimal part in prices
        decimalSize: 2, // Number of decimal places in prices
    },
    calendar: {
        monthFull: [
            'enero',
            'febrero',
            'marzo',
            'abril',
            'mayo',
            'junio',
            'julio',
            'agosto',
            'septiembre',
            'octubre',
            'noviembre',
            'diciembre',
        ], // Full names of months
        monthShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'], // Short names of months
        dayFull: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'], // Full names of days
        dayShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'], // Short names of days
        hours: 'Horas', // Label for hours
        minutes: 'Minutos', // Label for minutes
        done: 'Listo', // Label for done button
        clear: 'Reinicio', // Label for clear button
        today: 'Hoy', // Label for today button
    },
    dataExport: {
        page: 'Página', // Label for page
        of: 'de', // Label for of
    },
    PDFviewer: {
        of: 'de', // Label for of
        automaticZoom: 'Zoom automático', // Label for automatic zoom
        actualSize: 'Tamaño real', // Label for actual size
        pageFit: 'Tamaño de página', // Label for page fit
        pageWidth: 'Ancho de página', // Label for page width
        pageHeight: 'Altura de la página', // Label for page height
    },
    aria: {
        calendar: 'Сalendario', // ARIA label for calendar
        increaseValue: 'Aumentar el valor', // ARIA label for increase value
        decreaseValue: 'Disminuye el valor', // ARIA label for decrease value
        navMonth: ['Mes anterior', 'Próximo mes'], // ARIA labels for navigating months
        navYear: ['Año anterior', 'Próximo año'], // ARIA labels for navigating years
        navDecade: ['Década anterior', 'Próxima década'], // ARIA labels for navigating decades
        dateFormat: '%d %F %Y', // ARIA date format
        monthFormat: '%F %Y', // ARIA month format
        yearFormat: '%Y', // ARIA year format
        hourFormat: 'Horas: %G', // ARIA hour format
        minuteFormat: 'Minutos: %i', // ARIA minute format
        removeItem: 'Retire el elemento', // ARIA label for removing item
        pages: ['Primera página', 'Pagina anterior', 'Siguiente página', 'Última página'], // ARIA labels for pages
        page: 'Página', // ARIA label for page
        headermenu: 'Menú de títulos', // ARIA label for header menu
        openGroup: 'Grupo de columnas abiertas', // ARIA label for opening column group
        closeGroup: 'Primer grupo de columnas', // ARIA label for closing column group
        closeTab: 'Cerrar tab', // ARIA label for closing tab
        showTabs: 'Mostrar más tabs', // ARIA label for showing more tabs
        resetTreeMap: 'Volver a la vista original', // ARIA label for resetting tree map
        navTreeMap: 'Elevar a mismo nivel', // ARIA label for navigating tree map
        nextTab: 'Siguiente tab', // ARIA label for next tab
        prevTab: 'Tab anterior', // ARIA label for previous tab
        multitextSection: 'Añadir elemento', // ARIA label for adding element
        multitextextraSection: 'Retire el elemento', // ARIA label for removing element
        showChart: 'Espectáculo chart', // ARIA label for showing chart
        hideChart: 'Esconder chart', // ARIA label for hiding chart
        resizeChart: 'Cambiar el tamaño el chart', // ARIA label for resizing chart
    },
    richtext: {
        underline: 'Subrayar', // Label for underline
        bold: 'Negrita', // Label for bold
        italic: 'Itálico', // Label for italic
    },
    combo: {
        select: 'Seleccionar', // Label for select
        selectAll: 'Seleccionar todo', // Label for select all
        unselectAll: 'Deselecciona todo', // Label for unselect all
    },
};

// FILE DOCUMENTED
